(() => {
  /**
   * Bind product-image links directly instead of relying only on the theme's
   * delegated click handler. This keeps image 4 and later images zoomable on
   * mobile Safari after the active slide changes.
   */
  function bindGalleryLinks(root = document) {
    root.querySelectorAll('media-gallery[data-zoom-enabled]').forEach((gallery) => {
      gallery.querySelectorAll('a.show-gallery').forEach((link) => {
        if (link.dataset.yeeseGalleryBound === 'true') return;
        link.dataset.yeeseGalleryBound = 'true';

        link.addEventListener('click', (event) => {
          if (typeof gallery.openGalleryViewer !== 'function') return;

          event.preventDefault();
          event.stopPropagation();
          gallery.openGalleryViewer(event, link);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindGalleryLinks());
  } else {
    bindGalleryLinks();
  }

  document.addEventListener('shopify:section:load', (event) => bindGalleryLinks(event.target));
})();
